import {api} from './api';
import { DocumentResponse } from '../model/document';

export const putDocuments = async (accessToken: string, programId: string, documents: File[]): Promise<DocumentResponse> => {
    const form = new FormData();
    documents.forEach((doc) => {
        form.append(`documents`, doc);
    });

    const response = await api.put<DocumentResponse>(
        `/programs/${programId}/documents`, 
        form, {
        headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "multipart/form-data",
        }
    });

    return response.data;
};

export const getDocumentNames = async (accessToken: string, programId: string): Promise<string[]> => {
    const response = await api.get<string[]>(`/programs/${programId}/documents`, {
        headers: {
            Authorization: `Bearer ${accessToken}`,
        }
    });

    return response.data;
};

export const deleteDocument = async (accessToken: string, programId: string, documentName: string): Promise<void> => {
    await api.delete(`/programs/${programId}/documents/${documentName}`, {
        headers: {
            Authorization: `Bearer ${accessToken}`,
        }
    });
};